<template>
    <div>
        <div class="row" v-if="comments_data">
            <div class="col-12 pd-b-20" v-for="(data, index) in comments_data" :key="index">
                <div class="comment-group">
                    <div class="comment-group-divider" v-if="isCommentable">{{ index }}</div>
                    <div class="media" v-for="comment in data" :key="comment.id">
                        <div class="avatar avatar-sm">
                            <span v-if="comment.commenter.type === 'back-office'" class="avatar-initial rounded-circle bg-warning">IC</span>
                            <img v-else :src="comment.commenter.avatar" class="rounded-circle" alt="">
                        </div>
                        <div class="media-body">
                            <h6>
                                {{ (comment.commenter.id == user) ? 'You' : comment.commenter.name }}
                                <small class="tx-11 tx-color-03">{{ comment.created_at|toDate('LT') }}</small>
                            </h6>
                            <p class="tx-color-03 mg-b-0">{{ comment.comment }}</p>
                        </div>
                    </div>
                </div>
            </div>
			
			<div class="wd-100p" v-if="isCommentable">
				<div class="col-12" v-if="!isReplying">
					<div class="comment-group-buttons">
						<button type="button" class="btn btn-default shadow-sm" @click="isReplying =! isReplying">Reply</button>
					</div>
				</div>

				<form class="col-12" v-if="isReplying" @submit.prevent="sendMessage" @keydown="form.onKeydown($event)">
					<div class="form-group">
						<textarea v-model="form.reply" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('reply') }" rows="8" placeholder="Type here to Reply" :autofocus="isReplying" required></textarea>
						<has-error :form="form" field="reply" class="d-block"></has-error>
					</div>

					<div class="comment-group-buttons">
						<button-component :busy="form.busy" :label="'Send Message'" :label-loading="'Sending...'" :button-class="'btn btn-default shadow-sm'"></button-component>
						<button type="button" class="btn btn-primary shadow-sm" @click="isReplying =! isReplying">Cancel</button>
					</div>
				</form>
			</div>
        </div>
    </div>
</template>

<style scoped>
	.comment-group-divider {
		position: relative;
		display: flex;
		align-items: center;
		margin: 20px 0;
		color: #8392a5;
		font-size: 10px;
		font-weight: 500;
		letter-spacing: 0.5px;
		text-transform: uppercase;
	}

	.comment-group .media-body {
		margin-left: 20px;
	}

	.comment-group-buttons {
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.comment-group-buttons button:first-child {
		width: initial;
	}

	.comment-group-buttons button:not(:first-child) {
		margin-left: 0.25rem;
	}
</style>

<script>
	export default {
		data() {
			return {
				isReplying: false,
				user: this.$store.getters.user.id,
				form: new Form({
					reply: null
				})
			};
		},
		computed: {
			comments_data() {
				return _.groupBy(this.comments, comment => {
					const date = moment(comment.created_at, "YYYY-MM-DD").calendar(
						null,
						{
							sameDay: "[Today], MMM D",
							lastDay: "[Yesterday], MMM D",
							lastWeek: "[Last] dddd, MMM D",
							sameElse: "MMMM D YYYY"
						}
					);

					return date;
				});
			}
		},
		methods: {
			sendMessage() {
				this.form
					.post(`/api/messages/${this.$route.params.id}/comment`)
					.then(({ data }) => {
						this.comments.push(data.data.comment);

						this.form.clear();
						this.form.reset();
					});
			}
		},
		props: {
			comments: {
				default: []
			},
			isCommentable: {
				type: Boolean,
				default: true
			}
		}
	};
</script>